import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/jobs/offer/edit/$id/")({
  beforeLoad: ({ context, params }) => {
    const organizationBusinessUnitId = (
      context as { savedOrgBusinessUnit?: { id?: string } }
    ).savedOrgBusinessUnit?.id;
    if (!organizationBusinessUnitId) {
      throw redirect({ to: "/org/providers" });
    }
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id",
      params: { organizationBusinessUnitId, id: (params as { id: string }).id },
    });
  },
});
